import classes from './IllustrationWithProgress.module.scss';
import ProgressDonut from './ProgressDonut';

const IllustrationWithProgress = ({
  value,
  max,
  svg,
}: {
  value: number;
  max: number;
  svg: JSX.Element;
}): JSX.Element => {
  return (
    <div className={classes.container}>
      {svg}
      {value > 0 && <ProgressDonut value={value} max={max} />}
    </div>
  );
};

export default IllustrationWithProgress;
